import { Table } from "@/features/Table";
import { type Strategy, strategies_columns } from "./columns";
import { type FilterStrategySchema, FilterStrategy } from "./filter";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { ClientTables } from "@/lib/clientTables";

export const StrategiesTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;
  const { t } = useTranslation();

  return (
    <Table<Strategy, FilterStrategySchema>
      label={t("strategy.title", { ns: "tables", defaultValue: "Strategies" })}
      client={Clients.QTL}
      table_name={ClientTables.QTL_STRATEGIES}
      columns={strategies_columns}
      filter={<FilterStrategy />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
